import { useQuery } from "@tanstack/react-query";
import { getAllRoleApiRequest } from "../../services";

export const useGetAllRoleApi = () => {
  const { data, isLoading } = useQuery({
    queryKey: ["all-roles"],
    queryFn: () => getAllRoleApiRequest(),
    enabled: true,
  });
  return {
    allRole: data,
    isLoading,
  };
};
